module.exports = __webpack_public_path__ + "static/img/car.9ef08f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/car.png
// module id = 5AjI
// module chunks = 1